import { Tabs } from 'antd';
import { useState } from 'react';
import { ModuleVersionTab } from './module_version';
import { ReleaseTab } from './release';
import { RolloutTab } from './rollout';

export default function UpdateManagerPage() {
  const [moduleRefreshKey, setModuleRefreshKey] = useState(0);
  const [rolloutRefreshKey, setRolloutRefreshKey] = useState(0);
  const handleRolloutChanged = () => {
    setModuleRefreshKey((value) => value + 1);
    setRolloutRefreshKey((value) => value + 1);
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <Tabs
        items={[
          {
            key: 'release',
            label: '构建版本',
            children: (
              <ReleaseTab
                onReleaseChanged={() => setModuleRefreshKey((value) => value + 1)}
                onRolloutChanged={handleRolloutChanged}
              />
            ),
          },
          {
            key: 'module_version',
            label: '模块版本',
            children: <ModuleVersionTab refreshKey={moduleRefreshKey} onRolloutChanged={handleRolloutChanged} />,
          },
          {
            key: 'rollout',
            label: '模块灰度',
            children: <RolloutTab refreshKey={rolloutRefreshKey} />,
          },
        ]}
      />
    </div>
  );
}
